










































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {VueGoodTable} from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import Row from '@/components/ListView/interfaces/Row';
import InvestProgress from '@/components/Cockpit/InvestProgress/InvestProgress.vue';
import ExporoVue from '../ExporoVue';
import Logger from '../Helper/LogHelper';
import PrintHelper from '@/components/Helper/PrintHelper';
import UserTooltip from '@/components/User/Edit/UserTooltip.vue';
import UnreadUpdateDot from '@/components/UnreadUpdates/UnreadUpdateDot.vue';
import Events from '@/events';
import Router from '@/components/Router/Router';

@Component({
  components: {
    VueGoodTable,
    InvestProgress,
    UserTooltip,
    UnreadUpdateDot
  },
})
class ListView extends ExporoVue {

  @Prop()
  columns!: object[];

  @Prop()
  rows!: object[];

  private activeProjects: boolean = true;

  @Prop({
    default: () => {
    }
  })
  emptyAction!: any;

  @Prop({default: 'createdAt'})
  initialSort!: string;

  @Prop({default: false})
  groupEnabled!: boolean;

  @Prop({default: false})
  lockHeight!: boolean;

  @Prop()
  searchPlaceholder!: string;

  @Prop()
  onClick!: (row: Row) => void;

  @Prop() private userdata!: any;

  @Prop({default: true})
  selectable!: boolean;

  @Prop({default: 'No Data'})
  emptyState!: string;

  private tooltipText: string = 'Bitte beachten Sie, dass es sich hierbei um das avisierte Rückzahlungsdatum handelt. Im Projektentwicklungsgeschäft sind Terminverschiebungen nicht ungewöhnlich. Ihr Investment wird wie vertraglich vereinbart verzinst.';

  constructor() {
    super();
  }

  mounted() {

    Events.$on('filter', (x) => {
      this.activeProjects = x.selection === 'ongoingInvestments';
    });

    if (this.lockHeight) {
      const tableContainer: any = this.$refs['table'];

      if (tableContainer) {
        tableContainer.style.minHeight = tableContainer.offsetHeight;
      }
    }
  }

  routerPush(url) {
    window.location.href = url;
  }

  filterPrint() {
    const tableContainer: any = this.$refs['table'];
    const filterCol = tableContainer.getElementsByClassName('vgt-checkbox-col');
    const rows: any[] = [];

    [...filterCol].forEach((checkboxCol: any) => {
      const input = checkboxCol.getElementsByTagName('input')[0];

      if (!input.checked && !input.indeterminate) {
        if (input.parentNode && input.parentNode.parentNode) {
          const toHideNode: any = input.parentNode.parentNode;
          rows.push(toHideNode);
          toHideNode.style.display = 'none';

          const tableRow: any = toHideNode.parentNode.getElementsByTagName('tr')[1];
          if (tableRow.className.indexOf('clickable') === -1) {
            rows.push(tableRow);
            tableRow.style.display = 'none';
          }
        }
      }
    });
    return () => {
      rows.forEach((row: HTMLElement) => {
        row.style.display = '';
      });
    };
  }

  print() {

    let reverse: any = null;

    if (this.filterPrint) {
      reverse = this.filterPrint();
    }
    const tableContainer: any = this.$refs['table'];
    const progressCss = '.container{width:70%;margin:10px auto;max-width:100%}.progressbar{counter-reset:step}.progressbar li{list-style-type:none;width:25%;float:left;font-size:12px;position:relative;text-align:center;color:#7d7d7d}.progressbar li:before{width:40px;height:40px;content:counter(step);counter-increment:step;line-height:40px;border:2px solid #bbb;display:block;text-align:center;margin:0 auto 10px;border-radius:50%;background-color:#fff}.progressbar li:after{width:70%;height:3px;content:\'\';position:absolute;background-color:#bbb;top:18px;left:-35%;border-radius:20px}.progressbar li:first-child:after{content:none}.progressbar li.active{color:green}.progressbar li.active:before{border-color:#55b776}.progressbar li.active + li:after{background-color:#55b776}.progressbar li.in-progress + li:after{background-image:linear-gradient(90deg,#55b776,#55b776 50%,#bbb 50%)}.progress{height:100px;border-bottom:20px solid #fff}.progress:hover{background-color:initial}.progress:last-child{border-bottom:0 solid #fff}.vgt-table th.vgt-row-header{background-color: #fafafb;}.vgt-row-header a {    color: #274a7f;text-decoration: none;}';
    const listCss = '@page { size: landscape; }.right-arrow{display:none!important;}*{-webkit-print-color-adjust: exact;}.vgt-checkbox-col,.vgt-checkbox-col{display:none}table thead th.sorting:after{border-bottom:6px solid #fff}table thead th.sorting-desc:after{border-bottom:none!important;border-top:6px solid #fff}table thead th.sorting-desc,table thead th.sorting{color:#fff}table thead th:first-child{background:#90a2be!important;border:none!important}table tbody span{font-family:Open Sans,sans-serif;-webkit-font-smoothing:antialiased;color:#626262;font-size:12px;letter-spacing:.6px;font-weight:700;text-align:left}table .progress{height:20px}table img{will-change:height;-webkit-transition:height .5s ease-in-out;transition:height .5s ease-in-out;width:70px;height:50px;-o-object-fit:cover;object-fit:cover;margin:0!important;border-radius:3px;background-color:#ccc}table td{vertical-align:middle;padding:0}table .breadcrumb{margin:0 0 0 5px;padding:0;list-style:none;overflow:hidden;font:12px Sans-Serif}table .breadcrumb li{float:left;width:25%}table .breadcrumb li a{border-top-left-radius:4px;border-bottom-left-radius:4px;border:1px solid #90a2be;width:100%;text-align:center;color:#fff;text-decoration:none!important;padding:1px 5px 1px 45px;background:#90a2be;position:relative;display:block;float:left}table .breadcrumb li a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li a:after{content:" ";display:block;width:0;height:0;border-top:50px solid transparent;border-bottom:50px solid transparent;border-left:30px solid #90a2be;position:absolute;top:50%;margin-top:-50px;left:100%;z-index:2}table .breadcrumb li a:after.in-progress{border-left:30px solid transparent!important;color:#90a2be}table .breadcrumb li a:before{content:" ";display:block;width:0;height:0;border-top:50px solid transparent;border-bottom:50px solid transparent;border-left:30px solid #fff;position:absolute;top:50%;margin-top:-50px;margin-left:1px;left:100%;z-index:1}table .breadcrumb li:first-child a{padding-left:10px}table .breadcrumb li:nth-child(2) a{background:#8095b5}table .breadcrumb li:nth-child(2) a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(2) a:after{border-left-color:#8095b5}table .breadcrumb li:nth-child(2) a:after.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(3) a{background:#7087ab}table .breadcrumb li:nth-child(3) a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(3) a:after{border-left-color:#7087ab}table .breadcrumb li:nth-child(3) a:after.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(4) a{background:#607aa2}table .breadcrumb li:nth-child(4) a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(4) a:after{border-left-color:#607aa2}table .breadcrumb li:nth-child(4) a:after.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(5) a{background:#566d92}table .breadcrumb li:nth-child(5) a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:nth-child(5) a:after{border-left-color:#566d92}table .breadcrumb li:nth-child(5) a:after.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:last-child a{background:#4c6182!important;border-top-right-radius:4px;border-bottom-right-radius:4px;color:#fff;pointer-events:none;cursor:default}table .breadcrumb li:last-child a.in-progress{background:transparent!important;color:#90a2be}table .breadcrumb li:last-child a:after{border:0}table .breadcrumb li a:hover{background:#90a2be}table .breadcrumb li a:hover:after{border-left-color:#90a2be!important}.btn-in-table{transform:scale(0.7);font-size:14px;font-weight:700}.buy-bubble{background-color:#335586;border-radius:15px 0 0 0;position:absolute;bottom:0;right:0;color:#fff;padding:6px 8px;font-size:12px;font-weight:700;box-shadow:0 2px 10px rgba(0,0,0,0.1)}.table-row-container:last-child{display:flex;justify-content:space-between;align-items:center}.exporo-invest-list-root{width:100%;padding-bottom:80px}@keyframes appear{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0px)}}.list-mobile{align-items:center;margin-top:10px}.list-mobile-entry{border-radius:5px;width:100%;max-width:720px;box-shadow:0 2px 10px rgba(0,0,0,0.1);animation:appear 300ms forwards;opacity:0;transition:all 150ms ease;overflow:hidden;margin:auto}.list-mobile-entry + .list-mobile-entry{margin-top:20px}.list-mobile-entry:nth-child(1){animation-delay:100ms;transition-delay:100ms}.list-mobile-entry:nth-child(2){animation-delay:200ms;transition-delay:200ms}.list-mobile-entry:nth-child(3){animation-delay:300ms;transition-delay:300ms}.list-mobile-entry:nth-child(4){animation-delay:400ms;transition-delay:400ms}.list-mobile-entry:nth-child(5){animation-delay:500ms;transition-delay:500ms}.list-mobile-entry:nth-child(6){animation-delay:600ms;transition-delay:600ms}.list-mobile-entry:nth-child(7){animation-delay:700ms;transition-delay:700ms}.list-mobile-entry:nth-child(8){animation-delay:800ms;transition-delay:800ms}.list-mobile-entry:nth-child(9){animation-delay:900ms;transition-delay:900ms}.list-mobile-entry:nth-child(10){animation-delay:1000ms;transition-delay:1000ms}.list-mobile-entry:nth-child(11){animation-delay:1100ms;transition-delay:1100ms}.list-mobile-entry:nth-child(12){animation-delay:1200ms;transition-delay:1200ms}.list-mobile-entry:nth-child(13){animation-delay:1300ms;transition-delay:1300ms}.list-mobile-entry:nth-child(14){animation-delay:1400ms;transition-delay:1400ms}.list-mobile-entry:nth-child(15){animation-delay:1500ms;transition-delay:1500ms}.list-mobile-entry:nth-child(16){animation-delay:1600ms;transition-delay:1600ms}.list-mobile-entry:nth-child(17){animation-delay:1700ms;transition-delay:1700ms}.list-mobile-entry:nth-child(18){animation-delay:1800ms;transition-delay:1800ms}.list-mobile-entry:nth-child(19){animation-delay:1900ms;transition-delay:1900ms}.list-mobile-entry:nth-child(20){animation-delay:2000ms;transition-delay:2000ms}.list-mobile-preview{position:relative;min-width:180px;height:120px}.list-mobile-preview img{display:block;border-radius:0 0 0 5px;width:200px;height:130px;object-fit:cover}.list-mobile-title{position:absolute;background-color:rgba(255,255,255,.85);box-shadow:0 2px 5px rgba(0,0,0,.15);border-radius:50px;font-size:11px;font-weight:700;color:#335586;top:7px;left:7px;right:7px;padding:5px;text-align:center;text-transform:uppercase}.list-mobile-details{display:inline-block;float:left;width:100%;padding:10px 15px 10px 20px;background-color:#fff;border-radius:0 5px 5px 0;position:relative}.list-mobile-detail{display:inline-block;max-width:100px;margin:0}.list-mobile-value{font-size:16px;font-weight:700}.list-mobile-key{font-size:11px;color:#aaa;margin-top:2px}.list-mobile-expand{background-color:#335586;color:#fff;font-size:20px;position:absolute;right:-8px;bottom:45px;line-height:1;width:30px;height:30px;display:block;border-radius:50px;padding:5px 9px}.list-mobile-expand:before{content:"+"}.table-header{display:flex;justify-content:space-between;align-items:center}.sort-button{position:absolute;right:4px;top:16px}.sort-button-wrapper{width:20px}.vgt-global-search,.vgt-wrap__footer{border:none!important}.vgt-table thead th{vertical-align:middle}table{width:100%;border-collapse:unset;border-spacing:0 0;border:none!important}table-column-container{min-width:300px}table .id-row{padding-left:10px}table thead th{user-select:none;word-break:break-word;hyphens:auto;position:relative;text-align:left}table thead th:first-child{border-radius:5px 0 0 5px}table thead th:last-child{border-radius:0 5px 5px 0}table thead th.id{width:100px;min-width:100px}table thead tr{height:50px}table tbody{user-select:none}table tbody tr{border-radius:3px;cursor:pointer;transition:all .3s ease}table tbody tr td{border:none!important;position:relative}table tbody tr td:not(:first-child){padding-left:10px;padding-right:10px}table tbody tr td span + p{margin-left:15px}table tbody tr:hover td:last-child:after{border:1px solid rgba(0,0,0,0);color:#fff;transform:scale(1);background-color:#375884}table tr{height:60px;text-align:left;transition:background-color 2s ease}table tr:nth-child(odd){background-color:#f4f5f8}table tr:hover{background-color:#e7eaee}table tr.open{height:400px;width:72%;position:fixed;top:50%;margin-top:-200px;transition:all 300ms ease}table tr.open .open{position:absolute;right:0}table tr.open img{width:200px;height:200px}table p{display:block;float:left}table td p{margin:0;line-height:60px;height:60px}table div.open{width:40px;height:40px;background:#335586;color:#fff;font-size:30px;float:right;box-shadow:0 1px 10px 2px #000 59;line-height:36px;text-align:center;margin-right:10px;margin-top:10px;border-radius:20px}table th{padding-left:15px;padding-right:15px;height:40px;color:#fff;border:none!important;background:#51709c;text-transform:uppercase;font-size:11px;letter-spacing:.6px}table th:first-child{border:1px solid #dcdfe6!important}table th:last-child{min-width:130px}table th:nth-child(even){background-color:#90a2be}.info-card{position:relative;padding:20px 20px 25px;flex-grow:1;max-width:450px;transition:box-shadow .3s ease;margin:40px auto;text-align:center}.info-card-button{margin-top:20px}.mobile-image{display:none}@media screen and (max-width: 1200px){.mobile-image{display:none}table th{padding-left:7px;padding-right:7px}table th:first-child{min-width:auto;width:auto}table td{padding-left:7px;padding-right:7px}}@media screen and (max-width: 992px){.mobile-image{display:none}.list-mobile{display:inline}table{display:none}}@media screen and (max-width: 720px){.mobile-image{display:none}.tablet-image{display:none}.list-mobile-entry{max-width:480px}.list-mobile-preview{height:25px}.page-portfolio .list-mobile-details,.page-financing .list-mobile-details{grid-template-columns:1fr 1fr}.list-mobile-value{font-size:14px}.list-mobile-expand{right:-5px;bottom:-7px}.mobile-image{display:block!important}.tablet-image{display:none!important}.list-mobile .list-mobile-details.payment{padding:10px 20px 10px 10px;display:grid;grid-template-columns:1fr 1fr 1fr}.list-mobile .list-mobile-details .list-mobile-value{font-size:12px}.list-mobile .list-mobile-details .list-mobile-key{font-size:10px}.list-mobile .list-mobile-details img{position:absolute;object-fit:cover;width:114px;height:100%}.list-mobile-title{position:relative;box-shadow:none;border-radius:5px 5px 0 0;background-color:#335586;color:#fff;top:auto;left:auto;right:auto;width:100%;z-index:999}}@media screen and (min-width: 721px){.list-mobile-title{width:21%;z-index:999}}.hidden-sm{display:none}.container{width:100%;padding:0}.row{position:relative;width:100%;margin:0}.row.inline{display:inline-block;float:left;width:50%}.row.inline.small{display:inline-block;float:left;width:30%}.row [class^="col"]{float:left;min-height:.125rem}.row::after{content:"";display:table;clear:both}.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12{width:100%}.col-1-sm{width:8.3333333333%}.col-2-sm{width:16.6666666667%}.col-3-sm{width:25%}.col-4-sm{width:33.3333333333%}.col-5-sm{width:41.6666666667%}.col-6-sm{width:50%}.col-7-sm{width:58.3333333333%}.col-8-sm{width:66.6666666667%}.col-9-sm{width:75%}.col-10-sm{width:83.3333333333%}.col-11-sm{width:91.6666666667%}.col-12-sm{width:100%}@media only screen and (min-width: 45em){.col-1{width:8.3333333333%}.col-2{width:16.6666666667%}.col-3{width:25%}.col-4{width:33.3333333333%}.col-5{width:41.6666666667%}.col-6{width:50%}.col-7{width:58.3333333333%}.col-8{width:66.6666666667%}.col-9{width:75%}.col-10{width:83.3333333333%}.col-11{width:91.6666666667%}.col-12{width:100%}.hidden-sm{display:block}}.tooltip-container{display:none!important}';
    PrintHelper.print(tableContainer.getElementsByTagName('table')[0], [progressCss, listCss]);
    if (reverse) {
      reverse();
    }

  }

  exportCSV() {
    const {Parser} = require('json2csv');
    try {
      const tableContainer: any = this.$refs['table'];
      const fields = this.getTableFields(tableContainer.getElementsByTagName('thead'));
      const opts = {fields};
      const parser = new Parser(opts);
      const csv = parser.parse(this.filterCSVExport(tableContainer, fields));
      const hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'myExporoExport.csv';
      hiddenElement.click();
    } catch (err) {
      Logger.tag('Export CSV').error(err);
    }
  }

  filterCSVExport(tableContainer, fields) {
    const filterCol = tableContainer.getElementsByClassName('vgt-checkbox-col');
    const rows: any[] = [];
    [...filterCol].forEach((checkboxCol: any) => {
      const input = checkboxCol.getElementsByTagName('input')[0];
      const oneFormatedRow = {};
      let i = 0;
      if (input.checked && !input.indeterminate) {
        const row = input.parentNode.parentNode.children;
        [...row].forEach((c) => {
          if (c.tagName !== 'TH' && c.innerText) {
            oneFormatedRow[fields[i]] = c.innerText;
            ++i;
          }
        });
        rows.push(oneFormatedRow);
      }
    });
    return (rows);
  }

  getTableFields(tHeader) {
    const tHeaders = tHeader[0].children[0].children;
    const tableFields: any[] = [];
    [...tHeaders].forEach((h) => {
      if (h.innerText && h.innerText !== 'ACTION') {
        tableFields.push(h.innerText);
      }
    });
    return tableFields;
  }
}

export default ListView;
